import { GEnum } from '@/constants/enum.defination';
import i18n from '@/i18n';

export namespace CompetencyType {
  // コンピテンシータイプ別背景色
  export const bgColorClass = (type: GEnum.CompetencyType): string => {
    switch (type) {
      case GEnum.CompetencyType.Cognitive:
        return 'bg-cognitive';
      case GEnum.CompetencyType.Self:
        return 'bg-self';
      case GEnum.CompetencyType.Gift:
        return 'bg-gift';
      case GEnum.CompetencyType.Community:
        return 'bg-community';
      default:
        return 'bg-blue-8';
    }
  };
  // コンピテンシー別背景色
  export const competencyBgColorClass = (type: GEnum.CompetencyType): string => {
    switch (type) {
      case GEnum.CompetencyType.Cognitive:
        return 'bg-cognitive-competency';
      case GEnum.CompetencyType.Self:
        return 'bg-self-competency';
      case GEnum.CompetencyType.Gift:
        return 'bg-gift-competency';
      case GEnum.CompetencyType.Community:
        return 'bg-community-competency';
    }
  };

  // コンピテンシータイプ別ツールチップ文
  export const tooltipContent = (type: GEnum.CompetencyType): string => {
    switch (type) {
      case GEnum.CompetencyType.Cognitive:
        return i18n.t('TOOLTIP_COMPETENCY_TYPE_COMMUNITY').toString();
      case GEnum.CompetencyType.Self:
        return i18n.t('TOOLTIP_COMPETENCY_TYPE_SELF').toString();
      case GEnum.CompetencyType.Gift:
        return i18n.t('TOOLTIP_COMPETENCY_TYPE_GIFT').toString();
      case GEnum.CompetencyType.Community:
        return i18n.t('TOOLTIP_COMPETENCY_TYPE_COGNITIVE').toString();
    }
  };
  // コンピテンシータイプ別ボーダークラス
  export const borderClass = (type: GEnum.CompetencyType): string => {
    switch (type) {
      case GEnum.CompetencyType.Cognitive:
        return 'border-cognitive';
      case GEnum.CompetencyType.Self:
        return 'border-self';
      case GEnum.CompetencyType.Gift:
        return 'border-gift';
      case GEnum.CompetencyType.Community:
        return 'border-community';
    }
  };
  // コンピテンシータイプ別文字色
  export const textColorClass = (type: GEnum.CompetencyType): string => {
    switch (type) {
      case GEnum.CompetencyType.Cognitive:
        return 'text-cognitive';
      case GEnum.CompetencyType.Self:
        return 'text-self';
      case GEnum.CompetencyType.Gift:
        return 'text-gift';
      case GEnum.CompetencyType.Community:
        return 'text-community';
    }
  };

  export const colorCode = (type: GEnum.CompetencyType): string => {
    switch (type) {
      case GEnum.CompetencyType.Cognitive:
        return '#ad8b00';
      case GEnum.CompetencyType.Self:
        return '#f95a69';
      case GEnum.CompetencyType.Gift:
        return '#008080';
      case GEnum.CompetencyType.Community:
        return '#203863';
    }
  };

  export const competencyColorCode = (type: GEnum.CompetencyType): string => {
    switch (type) {
      case GEnum.CompetencyType.Cognitive:
        return '#fffde7';
      case GEnum.CompetencyType.Self:
        return '#fce4ec';
      case GEnum.CompetencyType.Gift:
        return '#e0f2f1';
      case GEnum.CompetencyType.Community:
        return '#e8eaf6';
    }
  };

  export const personalReportType = (type: GEnum.PersonalReportDisplayType): string => {
    switch (type) {
      case GEnum.PersonalReportDisplayType.NoShow:
        return i18n.t('NOT_SHOW').toString();
      case GEnum.PersonalReportDisplayType.SelfGrowthSupport:
        return i18n.t('SELF_GROWTH_SUPPORT_REPORT').toString();
      case GEnum.PersonalReportDisplayType.DiscoverStrengths:
        return i18n.t('STRENGTH_FIND').toString();
    }
  };
}
